import { useEffect } from 'react'

// Note: read by the page scrollbar rule in styles/base/default.scss, which hides the always-visible
// track while a modal is open so the backdrop fills the whole window
export const SCROLL_LOCKED_ATTRIBUTE = 'data-scroll-locked'

// Note: stacked modals each call the hook, but the body is locked once (by the first) and released
// once (by the last) - a later lock would measure a scrollbar that is already gone and reset the padding
let lockCount = 0
let lockedScrollY = 0

const lock = () => {
  lockCount += 1
  if (lockCount > 1) return

  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
  lockedScrollY = window.scrollY

  document.body.style.position = 'fixed'
  document.body.style.top = `-${lockedScrollY}px`
  document.body.style.width = '100%'
  document.body.style.paddingRight = `${scrollbarWidth}px`
  document.documentElement.setAttribute(SCROLL_LOCKED_ATTRIBUTE, '')
}

const unlock = () => {
  lockCount -= 1
  if (lockCount > 0) return

  document.body.style.removeProperty('position')
  document.body.style.removeProperty('top')
  document.body.style.removeProperty('width')
  document.body.style.removeProperty('padding-right')
  document.documentElement.removeAttribute(SCROLL_LOCKED_ATTRIBUTE)
  window.scrollTo(0, lockedScrollY)
}

// Note: Hook to lock body scroll when a modal/popup is open.
export const useLockBodyScroll = (isLocked = true) => {
  useEffect(() => {
    if (!isLocked) return

    lock()
    return unlock
  }, [isLocked])
}
